import React,{ useEffect } from 'react';
import Form from './FormSubGuild';
import * as Yup from 'yup';
import { useParams,useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const Update = () => {

    const { id } = useParams();
    const {readData} = useEntityCrud('Guild/GetSubGuild?subguildId=' + id);
    const {addData: updateData} = useEntityCrud('Guild/UpdateSubGuild');
    const {addData: updateSubData} = useEntityCrud('Guild/UpdateSubGuild');
    const navigate = useNavigate();
    
    const initialValues = {
        title: '',
        guildId: ''
    };

    useEffect(() => {
        readData().then(({data}) => {
            if(data.status)
                formik.setValues({
                    ...data.result
                });
        });
    },[]);
    
    const validationSchema = Yup.object({
        title: Yup.string()
        .required()
    });
    
    const onSubmit = (values) => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            title: values.title,
            id
        };
        if(values.guildId != ''){
            postedData.guildId = values.guildId;
            updateSubData(postedData).then(({data}) => {
                if(data.status){
                    toast.success('به روزرسانی صنف با موفقیت انجام شد');
                    return navigate('/guilds/sub-guilds/' + values.guildId);
                }else
                    data.errors.map(error => toast.error(error.message));
            }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
        }else{
            updateData(postedData).then(({data}) => {
                if(data.status){
                    toast.success('به روزرسانی صنف با موفقیت انجام شد');
                    return navigate('/guilds');
                }else
                    data.errors.map(error => toast.error(error.message));
            }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
        }
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const localStorageSubGuilds = localStorage.getItem("subGuilds")

    const handleBack = () => {
        navigate(`/guilds/sub-guilds/${localStorageSubGuilds}`,{replace: true});
        window.localStorage.removeItem("subGuilds")
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ویرایش صنف</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} hasParent={formik.values.guildId || false} />
            </div>
        </div>
    );
}

export default Update;